import { Component, Input, OnInit, Optional, Self } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { IconType } from '@ng-icons/core';

@Component({
    selector: 'mot-checkbox',
    templateUrl: './mot-checkbox.component.html',
    styleUrls: ['./mot-checkbox.component.scss'],
    standalone: false
})
export class MotCheckboxComponent implements ControlValueAccessor, OnInit {
  @Input() value: string;
  @Input() class: string;
  @Input() label: string;
  @Input() icon: IconType;

  formControl: FormControl;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
    if (this.ngControl) {
      this.formControl = this.ngControl.control as FormControl;
      if (this.value) {
        this.formControl.setValue(this.value);
      }
    }
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (!!this.formControl) {
      if (isDisabled) this.formControl.disable();
      else this.formControl.enable();
    }
  }
}
